import {pxToRem} from '../../../../utills/pxToRem'

// {base: '', lg: ''}
export const backLinkStyle = {
    color: 'cav_red',
    fontSize: {base: pxToRem(10), lg: 'xs'},
    fontWeight: 'medium',
    fontStyle: 'normal',
    letterSpacing: pxToRem(1)
}

export const normalTextStyle = {
    fontSize: {base: pxToRem(12), lg: pxToRem(13)},
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const tileStyle = {
    display: 'flex',
    flexDir: 'column',
    layerStyle: 'cardBordered',
    padding: {base: pxToRem(15), lg: `${pxToRem(23)} ${pxToRem(18)}`},
    gap: {base: pxToRem(10), lg: pxToRem(10)},
    boxShadow: `${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} rgba(0, 0, 0, 0.25)`,
    mt: '0 !important'
}

export const pageContainerStyle = {
    gap: {base: pxToRem(15), lg: pxToRem(25)},
    mt: {base: pxToRem(15), lg: pxToRem(64)},
    mb: {base: pxToRem(30), lg: pxToRem(40)},
    paddingX: {base: pxToRem(11), lg: pxToRem(45)}
}

export const pageHeadingStyle = {
    mb: '0 !important',
    fontFamily: 'Montserrat',
    fontWeight: 'semibold',
    fontSize: {base: 'lg', lg: pxToRem(22)},
    lineHeight: 'normal',
    letterSpacing: '3px'
}

export const orderItemContainerStyle = {
    gap: {base: pxToRem(15), lg: pxToRem(25)},
    mt: '0 !important',
    p: {
        ...normalTextStyle,
        fontSize: {base: pxToRem(14), lg: pxToRem(16)},
        margin: '0 !important'
    }
}

export const orderProductContainerStyle = {
    ...tileStyle,
    padding: {base: pxToRem(15), lg: `${pxToRem(23)} ${pxToRem(20)}`},
    gap: {base: pxToRem(15), lg: pxToRem(25)},
    h2: {
        ...normalTextStyle,
        a: {
            color: 'black',
            fontWeight: 'normal'
        }
    },
    hr: {
        margin: '0 !important',
        borderColor: 'cav_light_input_gray',
        bg: 'cav_light_input_gray',
        height: pxToRem(1)
    }
}
